<div
  #headerContainer
  class="section-header-container"
  [ngStyle]="{
    'background-color':
      (menu | productMenuBasicMethod: 'getShowSectionHeaderColorAsIcon')
        ? null
        : section?.metadata?.productsHeaderBackgroundColor,
    'background-size': 'cover',
    'background-image': headerBackgroundAsset$ | async,
    zoom: menu?.menuOptions?.productZoom || 1.0
  }">
  <ng-container *ngFor="let col of columnVMs">
    <div
      *ngIf="menu | getShouldInflateColumnHeaderForRow: section : col : sectionRowViewModels"
      class="section-column"
      [ngClass]="{ 'section-column-title': col.columnType === Types.SectionColumnProductInfoType.ProductTitle }"
      [style.width.%]="col.widthPercentage"
      [hidden]="menu | getShouldHideHeaderContent: section : col">
      <div
        *ngIf="col.columnType === Types.SectionColumnProductInfoType.ProductTitle"
        class="section-title"
        appScaleDownText
        [style.color]="menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section"
        [scaleEnabled]="!(menu | isPrintMenu)">
        {{ menu | productMenuBasicMethod: 'getSectionTitle' : section }}
        <div
          *ngIf="
            (menu | productMenuBasicMethod: 'getShowSectionHeaderColorAsIcon') &&
            (section?.metadata?.productsHeaderBackgroundColor | exists)
          "
          class="section-title-icon"
          [style.background-color]="section?.metadata?.productsHeaderBackgroundColor"></div>
      </div>
      <!-- see [1] before changing formatting -->
      @if (col.columnType === Types.SectionColumnProductInfoType.VariantPrice) {
        <app-header-column-variant-price [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.VariantSecondaryPrice) {
        <app-header-column-variant-secondary-price [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.QuantityAndSize) {
        <app-header-column-quantity-and-size [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.Quantity) {
        <app-header-column-quantity [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.Size) {
        <app-header-column-size [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.Asset) {
        <app-header-column-asset [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.StrainType) {
        <app-header-column-strain-type [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.Strain) {
        <app-header-column-strain [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.Lineage) {
        <app-header-column-lineage [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col?.columnType | isCannabinoidColumn) {
        <app-header-column-cannabinoid
          [menu]="menu"
          [section]="section"
          [colVm]="col"
          [sectionRowViewModels]="sectionRowViewModels"
          [cannabinoidColumnType]="col?.columnType | isCannabinoidColumn" />
      } @else if (col?.columnType | isTerpeneColumn) {
        <app-header-column-terpene
          [menu]="menu"
          [section]="section"
          [colVm]="col"
          [sectionRowViewModels]="sectionRowViewModels"
          [terpeneColumnType]="col?.columnType | isTerpeneColumn">
        </app-header-column-terpene>
      } @else if (col.columnType === Types.SectionColumnProductInfoType.Producer) {
        <app-header-column-producer [menu]="menu" [section]="section" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.Badge) {
        <app-header-column-badge [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.Brand) {
        <app-header-column-brand [menu]="menu" [section]="section" [colVm]="col" />
      } @else if (col.columnType === Types.SectionColumnProductInfoType.GradingResults) {
        <app-header-column-grading-results-score [menu]="menu" [section]="section" [colVm]="col" />
      }
    </div>
  </ng-container>
  <div [style.background-color]="section?.metadata?.productsHeaderBackgroundColor" class="gap-filler"></div>
</div>
